import React from "react";
import {FoodItem} from "../../../types";
import {motion} from "framer-motion";
import Action from "./action";

export const SingleFoodItem = ({
                                   item,
                                   col,
                               }: {
    item: FoodItem;
    col?: boolean;
}) => {
    const {title, price, imageURL, description} = item;
    const [imageLoaded, setImageLoaded] = React.useState(false);

    return (
        <motion.div
            whileTap={{rotate: [0, -1, 1, -1, 0]}}
            className={`${
                !col ? "w-[275px] min-w-[275px]" : "w-[320px] min-w-[320px]"
            } md:w-[300px] md:min-w-[300px] ${
                col ? "my-2" : "my-2 md:my-5"
            } h-auto bg-cardOverlay rounded-lg p-2 px-3 backdrop-blur-lg hover:drop-shadow-sm cursor-pointer`}
        >
            <div className="overflow-hidden w-full h-eqw flex items-center justify-between">
                {!imageLoaded}
                <motion.img
                    whileHover={{scale: 1.2}}
                    whileTap={{scale: 1.1}}
                    className="aspect-square object-cover object-center w-full h-eqw cursor-pointer rounded-lg"
                    style={{
                        opacity: imageLoaded ? "1" : "0",
                        transition: "opacity 2s ease-in",
                    }}
                    alt={description}
                    src={imageURL}
                    onLoad={() => setImageLoaded(true)}
                    loading="lazy"
                />
            </div>
            <div className="w-full flex items-end justify-end flex-col">
                <p className="text-textColor font-semi-bold text-lg">{title}</p>
                <p className="mt-1 text-sm text-gray-500">{description} </p>
                <div className="flex items-center justify-between gap-8 ">
                    <p className="text-base text-headingColor font-semibold">
                        <span className="text-sm text-buttonColor">Р</span> {price}
                    </p>
                    <Action food={item}/>
                </div>
            </div>
        </motion.div>
    );
};
